export default {
    slogan: {
        CH: "你与世界之间，只差一个携U行的距离",
        EN: "YOU・WORLD・UTRIP"
    },
    login: {
        CH: "登陆",
        EN: "Login"
    },

    signup: {
        CH: "注册",
        EN: "Signup"
    },

    signupWithWechat: {
        CH: "用微信登陆",
        EN: "Login with Wechat"
    },
    loginWithEmail: {
        CH: "用邮箱登陆",
        EN: "Login with email"
    },

    createNewAccount:{
        CH:"创建新账户",
        EN:"Create new account"
    },
    inputEmailAddress:{
        CH:"输入邮箱地址",
        EN:"Email address"
    },
    inputPassword: {
        CH:"输入 8 — 25 位密码",
        EN:"8 - 25 digit password"
    },
    clickToRegister :{
        CH:"点击登录",
        EN:"Click to Register"
    },
    forgotPassword: {
        CH:"忘记密码？",
        EN:"Forgot your password?"
    }

};


// WEBPACK FOOTER //
// ./src/Data/CH_EN_PAIR.js